import { PetScreeningAnimal, OurPetPolicyAnimal } from "shared/types";

export enum PetVerificationStatusEnum {
  VERIFIED = "VERIFIED",
  NOT_VERIFIED = "NOT_VERIFIED",
  NONE = "NONE"
}

export enum OurPetPolicyStatusEnum {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  NOT_APPROVED = "NOT_APPROVED",
  MOVED_IN = "MOVED_IN",
  MOVED_OUT = "MOVED_OUT",
  ARCHIVED = "ARCHIVED",
  RETRACTED = "RETRACTED",
  NONE = "NONE"
}

export enum PetScreeningStatusEnum {
  pending = "Pending",
  approved = "Approved",
  not_approved = "Not approved"
}

export enum TypeEnum {
  PET = "Pet",
  SA = "SA",
  ESA = "ESA"
}

export type Vaccine = {
  name: string;
  vaccinationDate: string;
  expirationDate: string;
};

export type RabiesVaccination = {
  vaccination_date: string;
  expiration_date: string;
};

export type OtherVaccination = {
  type: string;
  vaccination_date: string;
  expiration_date: string;
};

export type Vaccination = {
  is_vaccinated: boolean;
  rabies?: RabiesVaccination;
  other_vaccinations?: OtherVaccination[];
};

export type PetScreeningReportApplicantInfo = {
  animal_existence_status: boolean;
  details_page_url: string;
  email: string;
  id: string;
  name: string;
  pets_count: number;
  property: string;
  submission_time: number;
  unit: string;
};

export type PetScreeningReport = {
  pets?: (OurPetPolicyAnimal | PetScreeningAnimal)[];
  applicant_info?: PetScreeningReportApplicantInfo | null;
};
